import React, { useEffect, useState } from 'react';
import Cart from '../Cart/Cart';
import Product from '../Product/Product';
import './Body.css';

const Body = () => {

  const [products, setProducts] = useState([]);
  const [Time, setTime] = useState([]);


  useEffect( () =>{
      fetch('database.json')
      .then(res=> res.json())
      .then(data => setProducts(data))
  }, []);

  const handleAddToList = (time) =>{
    const newTime =parseInt([Time + time]);
    setTime(newTime);
}

  return (
    <div>
      <div className='product-body'>
        <div>
          <div className='header-text'>
          <img src="https://www.freeiconspng.com/thumbs/study-icon/study-icon-21.png" alt="" />
          <h1>Study Scheduler</h1>
          </div>
          <h2>Select today's reading Schedule</h2>
            <div className="products-container">
                {
                    products.map(product=><Product 
                        key={product.id}
                        product={product}
                        handleAddToList={handleAddToList}
                        ></Product>)
                }
            </div>
          </div>
        <Cart Time={Time}></Cart>
      </div>
    </div>
  );
};

export default Body;